<template>
  <div id="DataTables_Table_0_wrapper" class="dataTables_wrapper dt-bootstrap4">
    <div class="dataTables_length" id="DataTables_Table_0_length">
      <label>
        {{ $t("show") }}
        <select
          name="DataTables_Table_0_length"
          aria-controls="DataTables_Table_0"
          class="form-control form-control-sm"
          v-model="entries"
          @input="search()"
        >
          <option :value="10">10</option>
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
          <option :value="200">200</option>
          <option :value="500">500</option>
        </select>
        {{ $t("rows") }}
      </label>
    </div>
    <div id="DataTables_Table_0_filter" class="dataTables_filter">
      <div
        v-if="this.excel"
        class="btn btn-xs btn-primary my-1 mr-1"
        @click="downloadExcel()"
      >
        <i class="fa fa-ferfesh">{{ $t("download_excel") }}</i>
      </div>
      <div class="btn btn-xs btn-primary my-1" @click="getData('?page=' + 1)">
        <i class="fa fa-ferfesh">{{ $t("refresh_table") }}</i>
      </div>
    </div>
    <div
      class="dataTables_info"
      id="DataTables_Table_0_info"
      role="status"
      aria-live="polite"
    >
      Showing {{ entries * (current_page - 1) + 1 }} to {{ to }} of
      {{ total }} entries
    </div>
    <div id="scroll1" class="table-responsive">
      <div style="height: 1px"></div>
    </div>
    <div id="scroll2" class="table-responsive">
      <table
        class="
          table table-striped table-bordered table-hover
          dataTables-example
          dataTable
        "
        id="DataTables_Table_0"
        aria-describedby="DataTables_Table_0_info"
        role="grid"
      >
        <thead>
          <tr role="row">
            <th tabindex="0" rowspan="1" colspan="1">#</th>
            <th
              tabindex="0"
              rowspan="1"
              colspan="1"
              v-for="(column, i) in columns"
              :key="i"
            >
              <div style="position: relative">
                <input
                  v-if="column.type === 'text'"
                  type="text"
                  class="form-control"
                  v-model="column.search"
                  @input="search(column)"
                  autocomplete="off"
                />
                <date-picker
                  class="NeoDataPicker"
                  v-model="column.search"
                  :config="optionsDate"
                  :name="column.key"
                  v-else-if="column.type === 'date'"
                  @dp-change="search(column)"
                  autocomplete="off"
                />
                <select
                  class="form-control"
                  :name="column.key"
                  v-validate="'required'"
                  v-model="column.search"
                  v-else-if="column.type === 'list'"
                  @change="search(column)"
                  autocomplete="off"
                >
                  <option
                    v-for="(item, i) in column.list"
                    :key="i"
                    :value="item.name"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </th>
          </tr>
        </thead>
        <thead>
          <tr role="row">
            <th tabindex="0" rowspan="1" colspan="1">Lp</th>
            <th
              :class="{
                sorting:
                  column.sortable &&
                  (column.sort == null || column.sort == undefined),
                sorting_asc: column.sortable && column.sort == 'asc',
                sorting_desc: column.sortable && column.sort == 'desc',
              }"
              @click="changeSorting(column)"
              tabindex="0"
              rowspan="1"
              colspan="1"
              aria-sort="ascending"
              v-for="(column, i) in columns"
              :key="i"
            >
              {{ column.name }}
            </th>
          </tr>
        </thead>

        <draggable
          v-if="enabledSortDraggable == true"
          v-model="table_list"
          tag="tbody"
          @update="updateSortDraggable"
          handle=".handle"
        >
          <tr
            role="row"
            v-for="(row, i) in table_list"
            :key="i"
            :style="rowStyle(row)"
          >
            <td class="handle">
              {{ entries * (current_page - 1) + i + 1 }}
            </td>
            <td
              v-for="(column, j) in columns"
              :key="i + '-' + j"
              :class="{
                'text-center': column.filter == 'boolean',
                'text-right': column.filter == 'number',
              }"
            >
              <span
                @click="prepareFunctionToRun(row, column)"
                v-html="prepareDataToShow(row, column)"
              ></span>
            </td>
          </tr>
        </draggable>
        <tbody v-else>
          <tr
            role="row"
            v-for="(row, i) in table_list"
            :key="i"
            :style="rowStyle(row)"
          >
            <td>
              {{ entries * (current_page - 1) + i + 1 }}
            </td>
            <td
              v-for="(column, j) in columns"
              :key="i + '-' + j"
              :class="{
                'text-center': column.filter == 'boolean',
                'text-right': column.filter == 'number',
              }"
            >
              <span
                @click="prepareFunctionToRun(row, column)"
                v-html="prepareDataToShow(row, column)"
              ></span>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th rowspan="1" colspan="1">Lp</th>
            <th rowspan="1" colspan="1" v-for="(column, i) in columns" :key="i">
              {{ column.name }}
            </th>
          </tr>
        </tfoot>
      </table>
    </div>
    <div
      class="dataTables_paginate paging_simple_numbers"
      id="DataTables_Table_0_paginate"
    >
      <ul class="pagination">
        <li
          class="paginate_button page-item previous"
          :class="{ disabled: current_page === 1 }"
        >
          <a
            href="#"
            aria-controls="DataTables_Table_0"
            data-dt-idx="0"
            tabindex="0"
            class="page-link"
          >
            Previous
          </a>
        </li>
        <li
          class="paginate_button page-item"
          :class="{ active: current_page === 1 }"
          v-if="start >= 1"
        >
          <a
            href="#1"
            aria-controls="DataTables_Table_0"
            :data-dt-idx="1"
            tabindex="0"
            class="page-link"
            @click.prevent="getData('?page=' + 1)"
          >
            1
          </a>
        </li>
        <li class="paginate_button page-item" v-if="start > 1">
          <a
            href="#"
            aria-controls="DataTables_Table_0"
            :data-dt-idx="1"
            tabindex="0"
            class="page-link"
          >
            ...
          </a>
        </li>
        <li
          class="paginate_button page-item"
          :class="{ active: current_page === start + page_number }"
          v-for="(page_number, i) in end - start"
          :key="i"
        >
          <a
            :href="'#' + (start + page_number)"
            aria-controls="DataTables_Table_0"
            :data-dt-idx="start + page_number"
            tabindex="0"
            class="page-link"
            @click.prevent="getData('?page=' + (start + page_number))"
          >
            {{ start + page_number }}
          </a>
        </li>
        <li class="paginate_button page-item" v-if="end < last_page">
          <a
            href="#"
            aria-controls="DataTables_Table_0"
            :data-dt-idx="1"
            tabindex="0"
            class="page-link"
          >
            ...
          </a>
        </li>
        <li
          class="paginate_button page-item"
          :class="{ active: current_page === last_page }"
          v-if="end < last_page"
        >
          <a
            :href="'#' + last_page"
            aria-controls="DataTables_Table_0"
            :data-dt-idx="last_page"
            tabindex="0"
            class="page-link"
            @click.prevent="getData('?page=' + last_page)"
          >
            {{ last_page }}
          </a>
        </li>
        <li
          class="paginate_button page-item next"
          :class="{ disabled: current_page === last_page }"
        >
          <a
            href="#"
            aria-controls="DataTables_Table_0"
            data-dt-idx="4"
            tabindex="0"
            class="page-link"
            @click.prevent="getData('?page=' + (current_page + 1))"
          >
            Next
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'DataTable',
  components: {
    draggable
  },
  data() {
    return {
      enabledSortDraggable: false,
      valueFromExcel: [],
      entries: 10,
      current_page: 1,
      last_page: 1,
      total: 0,
      table_list: [],
      to: 0,
      pagination_link_count: 7
    }
  },
  props: {
    excel: {
      type: Boolean,
      default: false
    },
    draggableSort: {
      type: Boolean,
      default: false
    },
    dateStart: {
      type: String,
      default: null
    },
    dateEnd: {
      type: String,
      default: null
    },
    url: {
      type: String,
      required: true
    },
    columns_list: {
      type: Array,
      required: true
    },
    addData: {
      required: false,
      default: null
    },
    rowStyle: {
      type: Function,
      default: () => ''
    },
    empikPost: {
      type: Boolean,
      default: false
    },
    giftCardUsed: {
      type: Boolean,
      default: false
    },
    fileName: {
      type: String,
      default: 'excel'
    }
  },

  watch: {
    entries: async function() {
      const query = Object.assign( {}, this.$route.query )
      query.entries = this.entries
      await this.$router.push( { query } )
    },
    current_page: async function() {
      const query = Object.assign( {}, this.$route.query )
      query.page = this.current_page
      await this.$router.push( { query } )
    },
    url: function() {
      this.getData()
    },
    dateStart: function() {
      this.getData()
    },
    dateEnd: function() {
      this.getData()
    },
    addData: {
      handler() {
        this.getData()
      },
      deep: true
    }
  },
  computed: {
    columns() {
      return this.columns_list.filter(
        column => column.show === undefined || column.show === true
      )
    },
    start() {
      return this.current_page - this.pagination_link_count > 0
        ? this.current_page - this.pagination_link_count
        : 1
    },
    end() {
      return this.current_page + this.pagination_link_count < this.last_page
        ? this.current_page + this.pagination_link_count
        : this.last_page
    },
    newUrl() {
      return this.url.split( '?' )[ 0 ].replace( /\/$/, '' )
    },
    queryParams() {
      return this.url.split( '?' ).length > 1 ? this.url.split( '?' )[ 1 ] : ''
    }
  },
  created() {
    this.entries = this.$route.query.entries || this.entries
    this.current_page = this.$route.query.page || this.current_page
    this.enabledSortDraggable = this.draggableSort
    this.getData()
  },
  mounted() {
    document.querySelector( '#scroll1' ).addEventListener( 'scroll', this.scroll )
    document.querySelector( '#scroll2' ).addEventListener( 'scroll', this.scroll )
  },
  updated() {
    document.querySelector( '#scroll1 div' ).style.width = `${
      document.querySelector( '#scroll2 table' ).clientWidth
    }px`
  },
  beforeDestroy() {
    if ( document.querySelector( '#scroll1' ) ) {
      document
        .querySelector( '#scroll1' )
        .removeEventListener( 'scroll', this.scroll )
    }
    if ( document.querySelector( '#scroll2' ) ) {
      document
        .querySelector( '#scroll2' )
        .removeEventListener( 'scroll', this.scroll )
    }
  },
  methods: {
    updateSortDraggable() {
      this.$emit( 'updateDraggableSort', this.table_list )
    },
    scroll( e ) {
      if ( e.target.id === 'scroll1' ) {
        document.querySelector( '#scroll2' ).scrollLeft = e.target.scrollLeft
      } else {
        document.querySelector( '#scroll1' ).scrollLeft = e.target.scrollLeft
      }
    },
    changeSorting( column ) {
      if ( column.sortable ) {
        this.columns.map( column2 => {
          if ( column2 !== column ) {
            column2.sort = null
          }
          return column2
        } )
        if ( column.sort === null || column.sort === undefined ) {
          column.sort = 'asc'
        } else if ( column.sort === 'asc' ) {
          column.sort = 'desc'
        } else {
          column.sort = null
        }
        this.checkEnabledSortDraggable()
        this.$forceUpdate()
        this.getData()
      }
    },
    checkEnabledSortDraggable() {
      if ( this.draggableSort == true ) {
        const check = this.columns.map( column => {
          if (
            ( column.sort !== undefined && column.sort !== null ) ||
            ( column.search !== undefined && column.search !== '' )
          ) {
            return true
          }
          return false
        } )
        if ( check.includes( true ) ) {
          this.enabledSortDraggable = false
        } else {
          this.enabledSortDraggable = true
        }
      }
    },
    search( column = true ) {
      this.$forceUpdate()
      this.current_page = 1
      this.$nextTick( () => {
        if ( !column.search ) {
          this.getData()
          return 0
        }
        if ( column.search.length >= 1 ) {
          this.getData()
        }
      } )
      this.checkEnabledSortDraggable()
    },
    getData( page = '' ) {
      this.$emit( 'loading', true )
      const filter = {
        entries: this.entries,
        dateStart: this.dateStart,
        dateEnd: this.dateEnd,
        addData: this.addData,
        sort: {}
      }
      this.columns.map( column => {
        filter[ column.key ] = column.search || ''
        if ( column.sort !== undefined && column.sort !== null ) {
          filter.sort[ column.key ] = column.sort
        }
        return filter
      } )
      if ( page === '' ) {
        page = `?page= ${this.$route.query.page || 1}`
      }
      this.$forceUpdate()
      this.$nextTick( () => {
        const queryParams = this.prepareQueryParams( '&' )
        this.$http
          .post( this.newUrl + page + queryParams, filter )
          .then( resp => {
            if ( this.empikPost ) {
              this.table_list = resp.data.offers
              console.log( this.$route.query.page )
              this.current_page = this.$route.query.page || 1
              this.last_page = Math.ceil( resp.data.total_count / this.entries )
              this.total = resp.data.total_count
              this.to = 9
              this.$emit( 'list', this.table_list.length )
              this.$emit( 'loading', false )
            } else {
              console.log( this.$route.query.page )
              this.table_list = resp.data.table.data
              this.current_page = resp.data.table.current_page
              this.last_page = resp.data.table.last_page
              this.total = resp.data.table.total
              this.to = resp.data.table.to
              this.$emit( 'list', this.table_list.length )
              this.$emit( 'loading', false )
            }
          } )
          .catch( err => {
            this.$toastr.error( err )
            this.$emit( 'loading', false )
          } )
      } )
    },
    downloadExcel() {
      this.$emit( 'loading', true )
      const filter = {
        dateStart: this.dateStart,
        dateEnd: this.dateEnd,
        addData: this.addData,
        excel: true,
        sort: {}
      }
      this.columns.map( column => {
        filter[ column.key ] = column.search || ''
        if ( column.sort !== undefined && column.sort !== null ) {
          filter.sort[ column.key ] = column.sort
        }
        return filter
      } )
      this.$forceUpdate()
      this.$nextTick( () => {
        const queryParams = this.prepareQueryParams()
        this.$http( {
          url: `${this.newUrl}/download${queryParams}`,
          method: 'POST',
          responseType: 'blob',
          data: this.columns
        } )
          .then( response => {
            const url = window.URL.createObjectURL( new Blob( [ response.data ] ) )
            const link = document.createElement( 'a' )
            link.href = url
            link.setAttribute(
              'download',
              `${this.fileName}-${this.$moment().format( 'YYYY-mm-d' )}.xlsx`
            )
            document.body.appendChild( link )
            link.click()
          } )
          .catch( err => {
            this.$toastr.error( err )
            this.$emit( 'loading', false )
          } )
          .finally( () => {
            this.$toastr.success( 'Pobrany excel' )
            this.$emit( 'loading', false )
          } )
      } )
    },
    prepareQueryParams( param = '?' ) {
      let queryParams = ''
      if ( this.queryParams !== '' ) {
        queryParams = `${param}${this.queryParams}`
      }
      return queryParams
    },
    prepareDataToShow( row, column ) {
      if ( column.filter ) {
        switch ( column.filter ) {
          case 'boolean':
            return ( row[ column.key ] !== 0 && row[ column.key ] !== '' ) ||
              row[ column.key ] === 'on'
              ? '<i class="fa fa-check text-info"></i>'
              : '<i class="fa fa-times text-danger"></i>'
          case 'image':
            return row[ column.key ] !== null
              ? `<img src="${row[ column.key ]}" width="${column.width}" />`
              : ''
          case 'btn':
            return column.btn( row[ column.key ], row, column.key )
          case 'function':
            return column.col_function( row[ column.key ], row, column.key )
          case 'number':
            return row[ column.key ].toString().replace( '.', ',' )
        }
      }
      return row[ column.key ]
    },
    prepareFunctionToRun( row, column ) {
      if ( column.touch ) {
        column.function( row[ column.key ], row, column.key )
        this.$forceUpdate()
        if ( column.dont_refresh === undefined || !column.dont_refresh ) {
          this.getData( `?page= ${this.current_page}` )
        }
      }
    }
  }
}
</script>

<style scoped>
.handle {
  cursor: move;
}
</style>
